
import { getItem } from '../../common/common/enum';
import IconDefault from '../../assets/img/map_tool_default.png';
import IconKn from '../../assets/img/map_tool_kn.png';

const TOOL_INFO = {
    toolId: 'Info',
    iconSrc: IconDefault,
    title: 'Informace o objektu v mapě'
};

const TOOL_KN = {
    toolId: 'Kn',
    iconSrc: IconKn,
    title: 'Nahlížení do KN'
};

const TOOL_MODIFY_FEATURE = {
    toolId: 'ModifyFeature',
    iconName: 'EditCreate',
    title: 'Upravit geometrii'
};

const TOOL_DRAW_POINT = {
    toolId: 'DrawPoint',
    iconName: 'Edit',
    title: 'Nakreslit bod'
};

const TOOL_DRAW_LINE = {
    toolId: 'DrawLine',
    iconName: 'Edit',
    title: 'Nakreslit linii'
};

const TOOL_DRAW_POLYGON = {
    toolId: 'DrawPolygon',
    iconName: 'Edit',
    title: 'Nakreslit polygon'
};

const TOOL_MEASURE_POINT = {
    toolId: 'MeasurePoint',
    iconMultiSceneCore: 'MeasurePoint',
    title: 'Zjistit souřadnice bodu'
};

const TOOL_MEASURE_LINE = {
    toolId: 'MeasureLine',
    iconMultiSceneCore: 'MeasureLine',
    title: 'Měření vzdálenosti'
};

const TOOL_MEASURE_POLYGON = {
    toolId: 'MeasurePolygon',
    iconMultiSceneCore: 'MeasurePolygon',
    title: 'Měření plochy'
};

const TOOL_MEASURE_MODIFY = {
    toolId: 'MeasureModify',
    iconMultiSceneCore: 'MeasureEdit',
    title: 'Editace měření'
};

const TOOLS = [
    TOOL_INFO, TOOL_KN,
    TOOL_DRAW_POINT, TOOL_DRAW_LINE, TOOL_DRAW_POLYGON,
    TOOL_MEASURE_POINT, TOOL_MEASURE_LINE, TOOL_MEASURE_POLYGON, TOOL_MEASURE_MODIFY
];

export const DEFAULT = 'DEFAULT';
export const MEASURE = 'MEASURE';
export const INPUT_LINE = 'INPUT_LINE';
export const INPUT_POINT = 'INPUT_POINT';
export const INPUT_POLYGON = 'INPUT_POLYGON';
export const MODIFY_FEATURE = 'MODIFY_FEATURE';

export function getTool(toolId) {
    return TOOLS.reduce((previous, current) => {
        return (current.toolId === toolId)
            ? current
            : previous;
    }, null);
}

export function getTools(value, options = {}) {
    const ITEMS = [{
        key: DEFAULT,
        tools: (options.nahlizeniDoKn)
            ? [TOOL_INFO, TOOL_KN]
            : [TOOL_INFO]
    },{
        key: MEASURE,
        tools: [TOOL_INFO, TOOL_MEASURE_POINT, TOOL_MEASURE_LINE, TOOL_MEASURE_POLYGON, TOOL_MEASURE_MODIFY]
    },{
        key: INPUT_LINE,
        tools: [TOOL_INFO, TOOL_DRAW_LINE, TOOL_MODIFY_FEATURE]
    },{
        key: INPUT_POINT,
        tools: [TOOL_INFO, TOOL_DRAW_POINT, TOOL_MODIFY_FEATURE]
    },{
        key: INPUT_POLYGON,
        tools: [TOOL_INFO, TOOL_DRAW_POLYGON, TOOL_MODIFY_FEATURE]
    },{
        key: MODIFY_FEATURE,
        tools: [TOOL_MODIFY_FEATURE]
    }];

    return getItem(ITEMS, value).tools;
}
